// AUTO-GENERATED by scripts/frontend-config-build.mjs — do not edit.
export const exposedConfig = {
  "i18n": {
    "datePattern": "DMY",
    "hour12": false,
    "currency": "BRL",
    "separatorLocale": "pt-BR",
    "supportedLocales": [
      "pt-BR",
      "en",
      "es",
    ],
    "defaultLocale": "pt-BR",
    "localeEndonyms": {
      "pt-BR": "Português",
      "en": "English",
      "es": "Español",
    },
  },
  "support": {
    "email": "support@takove.example",
  },
  "auth": {
    "minPasswordLength": 8,
  },
} as const;
